var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: "" } },
    [
      _c(
        "w-card",
        { attrs: { "max-width": "500" } },
        [
          _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("rename-sale-type")))]),
          _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-input", {
                        attrs: { fancy: "", label: _vm.$ct("sale-type-name") },
                        model: {
                          value: _vm.name,
                          callback: function ($$v) {
                            _vm.name = $$v
                          },
                          expression: "name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-input", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("sale-type-name-plural"),
                        },
                        model: {
                          value: _vm.namePlural,
                          callback: function ($$v) {
                            _vm.namePlural = $$v
                          },
                          expression: "namePlural",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban", disabled: _vm.saving },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: { icon: "save", disabled: _vm.saving },
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.save")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }